// extracted by mini-css-extract-plugin
module.exports =  {"skeleton-sized-circle":"SkeletonSized-module__skeleton-sized-circle___xDC0s"};